module.exports = __webpack_public_path__ + "img/service.29ea64f0.png";